import { render, staticRenderFns } from "./BookingDetailGroup.vue?vue&type=template&id=470d5bd7&scoped=true"
import script from "./BookingDetailGroup.vue?vue&type=script&lang=js"
export * from "./BookingDetailGroup.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailGroup.vue?vue&type=style&index=0&id=470d5bd7&prod&lang=scss&scoped=true"
import style1 from "./BookingDetailGroup.vue?vue&type=style&index=1&id=470d5bd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470d5bd7",
  null
  
)

export default component.exports